import { create } from "zustand";
import { persist } from "zustand/middleware";
import type { GymResolveResponse } from "@/lib/api/public";

interface GymResolverState {
  /** Resolved gym display name — null until gym is picked. */
  displayName: string | null;
  /** Short-lived resolution token from the resolver endpoint. */
  resolutionToken: string | null;
  /** Resolved branch id — null when multi-branch chooser is pending. */
  branchId: string | null;
  /** Full resolver payload (branding, flags). */
  resolved: GymResolveResponse | null;
  /**
   * API base for member-facing calls after gym resolution.
   * Defaults to "/api/v1" (relative). Cross-origin values require
   * DevOps CORS + auth-cookie sign-off before use.
   */
  apiBase: string;
  setResolved: (payload: GymResolveResponse, branchId?: string | null, apiBase?: string) => void;
  clear: () => void;
}

export const useGymResolverStore = create<GymResolverState>()(
  persist(
    (set) => ({
      displayName: null,
      resolutionToken: null,
      branchId: null,
      resolved: null,
      apiBase: "/api/v1",
      setResolved: (payload, branchId = null, apiBase = "/api/v1") =>
        set({
          displayName: payload.display_name,
          resolutionToken: payload.resolution_token,
          branchId: branchId ?? null,
          resolved: payload,
          apiBase: apiBase ?? "/api/v1",
        }),
      clear: () => set({ displayName: null, resolutionToken: null, branchId: null, resolved: null, apiBase: "/api/v1" }),
    }),
    { name: "gymviz.gym.resolver" },
  ),
);
